__turbopack_context__.v({
  "carousel": "FullscreenImageGallery-module__EXzhma__carousel",
  "closeButton": "FullscreenImageGallery-module__EXzhma__closeButton",
  "dimmedBackground": "FullscreenImageGallery-module__EXzhma__dimmedBackground",
});
